import { AccountPaymentMethod } from './payment-accounts/account-payment-method.model';
import { PaymentStatus } from './payment-status.enum';

export interface ConvenienceFeeInfo {
  documentsCount: number;
  subTotal: number;
  docInfo: DocInfo[];
  currency?: string;
  paymentAccountId: number;
}

export interface DocInfo {
  documentId: number;
  documentIdBurn: string;
  paymentAmount: number;
  invoiceNumber?: string;
  description?: string;
}

export interface CustomerPayment {
  masterConfirmationNumber?: string;
  paymentDate?: string;
  isScheduledPayment?: boolean;
  status?: PaymentStatus;
  paymentType?: AccountPaymentMethod;
  paymentMethodDisplayName?: string;
  currency?: string;
  companyName?: string;
}

export enum SessionDocumentType {
  Invoice = 'invoice',
  CreditMemo = 'creditmemo',
  Statement = 'statement',
  Unknown = 'unknown',
}
